import * as React from 'react';
import { IArticleElements } from '../models/article-elements'


interface IProps {
    content: IArticleElements;
}

export class NewsContent extends React.Component<IProps, any> {
    render() {
        const { content } = this.props;
        return (
            <div className="news-content-container">
                <h4 className="title-link"><a href={content.pageLink}>{content.title}</a></h4>
                <span>{content.displayDate}</span>
                <div className="cta-card-body-description"><span dangerouslySetInnerHTML={{ __html: content.description }}></span></div>

            </div>

        );
    }
}